module.exports = __webpack_public_path__ + "static/media/admin.75ba7ce5.jpg";